import { memo } from 'react';

function LeftIcon({
	className,
	calendar,
}: {
	className?: string;
	calendar?: boolean;
}) {
	if (calendar) {
		return (
			<svg
				width="8"
				height="12"
				viewBox="0 0 8 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
			>
				<path
					d="M6.24608 10.5L1.74609 6L6.2461 1.49999"
					stroke="currentColor"
					strokeWidth="1.64454"
					strokeLinecap="square"
				/>
			</svg>
		);
	}
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="6"
			height="8"
			viewBox="0 0 6 8"
			fill="none"
			className={className}
		>
			<path
				stroke="currentColor"
				strokeLinecap="square"
				d="M4.37 7.04 1.632 4.302l2.736-2.737"
			/>
		</svg>
	);
}

export default memo(LeftIcon);
